import React from 'react';
import ConfigurationLayout from 'components/configuration/ConfigurationLayout';
import { useIsMediaLibrary } from 'hooks/use-is-media-library';
import { cn } from 'lib/utils';

interface FileManagerLayoutProps {
  children: React.ReactNode;
  headerToolbar: React.ReactNode;
  modals: React.ReactNode;
}

export const FileManagerLayout: React.FC<FileManagerLayoutProps> = ({
  children,
  headerToolbar,
  modals,
}) => {
  const isMediaLibrary = useIsMediaLibrary();

  const content = (
    <div
      className={cn(
        'flex w-full flex-col',
        isMediaLibrary ? 'min-h-full' : 'h-full min-h-0 overflow-hidden'
      )}
    >
      <div className="shrink-0">{headerToolbar}</div>

      <div
        className={cn(
          isMediaLibrary
            ? 'w-full'
            : 'flex min-h-0 flex-1 overflow-hidden justify-center px-4 sm:px-6'
        )}
      >
        <div
          className={cn(
            isMediaLibrary
              ? 'w-full min-w-0'
              : 'flex min-h-0 w-full flex-1 flex-col overflow-hidden max-w-[829px]'
          )}
        >
          {children}
        </div>
      </div>

      {modals}
    </div>
  );

  if (!isMediaLibrary) return content;

  return (
    <ConfigurationLayout className="min-h-full gap-0 py-0 sm:py-0">
      {content}
    </ConfigurationLayout>
  );
};
